function cartAnimation() {
  // console.log('cartAnimation');
}

export default cartAnimation;
